// src/data/featuredArticles.js

export const FEATURED_ARTICLES = [
  {
    id: "featured:lanna-crafts",
    categoryKey: "bookArticles.categories.lannaHeritage",
    tagKeys: [
      "bookArticles.tags.craftsman",
      "bookArticles.tags.lanna",
      "bookArticles.tags.history",
    ],
    path: "/lanna-crafts",
    cover: "/LannaCraftsPage/0.png",
    titleKey: "bookArticles.featuredArticles.lannaCrafts.title",
    descKey: "bookArticles.featuredArticles.lannaCrafts.desc",
  },
  {
    id: "featured:rare-books",
    categoryKey: "bookArticles.categories.archives",
    tagKeys: [
      "bookArticles.tags.rareBooks",
      "bookArticles.tags.archives",
    ],
    path: "/rare-books-lanna",
    cover: "/assets/หอสมุดแห่งชาติรัชมังคลาภิเษก เชียงใหม่.jpg",
    titleKey: "bookArticles.featuredArticles.rareBooks.title",
    descKey: "bookArticles.featuredArticles.rareBooks.desc",
  },
  {
    id: "featured:temple-exhibition",
    categoryKey: "bookArticles.categories.exhibitions",
    tagKeys: [
      "bookArticles.tags.map",
      "bookArticles.tags.temple",
      "bookArticles.tags.community",
    ],
    kind: "static",
    path: "/temple-exhibition",
    cover: "/TempleExhibitionPage/cover-temp.webp",
    titleKey: "bookArticles.featuredArticles.templeExhibition.title",
    descKey: "bookArticles.featuredArticles.templeExhibition.desc",
  },
  {
    id: "featured:inthakin-pillar",
    categoryKey: "bookArticles.categories.lannaHeritage", // ใช้หมวดหมู่มรดกล้านนา
    tagKeys: [
      "bookArticles.tags.lanna",
      "bookArticles.tags.history",
      "bookArticles.tags.temple", // ใช้ tag วัด ประวัติศาสตร์ และล้านนา
    ],
    kind: "static", 
    path: "/inthakin-article", // Path ที่จะลิงก์ไปหาไฟล์ InthakinArticlePage.jsx
    cover: "/InthakinArticlePage/inthakin-pillar.png", // รูปหน้าปก (ใช้รูปจากแผ่นแรก)
    titleKey: "bookArticles.featuredArticles.inthakin.title",
    descKey: "bookArticles.featuredArticles.inthakin.desc",
  },
  {
    id: "featured:wat-umong",
    categoryKey: "bookArticles.categories.lannaHeritage", // หมวดหมู่มรดกล้านนา
    tagKeys: [
      "bookArticles.tags.lanna",
      "bookArticles.tags.history",
      "bookArticles.tags.temple", // tag วัด ประวัติศาสตร์ และล้านนา
    ],
    kind: "static", 
    path: "/wat-umong-article", // Path ที่จะลิงก์ไปหาไฟล์ WatUmongArticlePage.jsx (ปรับให้ตรงกับ Router ของคุณ)
    cover: "/WatUmongArticlePage/page14-mid.webp", // รูปหน้าปก ใช้รูปแรกของบทความ (เจดีย์อุโมงค์)
    titleKey: "bookArticles.featuredArticles.watUmong.title",
    descKey: "bookArticles.featuredArticles.watUmong.desc",
  }
];